import { render, staticRenderFns } from "./FormTextarea.vue?vue&type=template&id=7c6afb99&scoped=true"
import script from "./FormTextarea.vue?vue&type=script&lang=js"
export * from "./FormTextarea.vue?vue&type=script&lang=js"
import style0 from "./FormTextarea.vue?vue&type=style&index=0&id=7c6afb99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6afb99",
  null
  
)

export default component.exports